<template>
  <ul class="mt-2">
    <li
      v-for="pair in activationsByTiming"
      :key="pair[0].startdate + pair[0].stopdate"
    >
      <span class="mr-1">
        {{ pair[0].startdate | dayjs('DD.MM.YYYY') }} -
        {{ subtractOneDayFromDate(pair[0].stopdate) | dayjs('DD.MM.YYYY') }}
      </span>
      <span>({{ $t('in') }} {{ pair[1].length }} {{ $t('stores') }})</span>
    </li>
  </ul>
</template>

<script>
import timing from '@/mixins/timing';

export default {
  mixins: [timing],
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    /**
     * Group activations by their shared start/enddates.
     *
     * Used to list those timings and the number of stores it was used on.
     *
     * Returns:
     *   [
     *       // The timing                      // List of activations
     *     [ {startdate: '..', stopdate: '..'}, [ {..}, {..}, {..}] ],
     *     [ {startdate: '..', stopdate: '..'}, [ {..}, {..}, {..}] ],
     *   ]
     */
    activationsByTiming() {
      const timingToActivations = {};
      this.campaign.activations.forEach((activation) => {
        const timing = `${activation.startdate} to ${activation.stopdate}`;
        if (!timingToActivations[timing]) {
          timingToActivations[timing] = [];
        }
        timingToActivations[timing].push(activation);
      });
      // So as this is grouped now, return a flat list of pairs for
      // making it easier to display it in the template. The first
      // item is an object with startdate and stopdate, the second is
      // a list of activations for that timing.
      const result = [];

      const timingKeys = Object.keys(timingToActivations);
      timingKeys.sort();
      timingKeys.forEach((timingKey) => {
        const activations = timingToActivations[timingKey];
        const timingObj = {
          startdate: activations[0].startdate,
          stopdate: activations[0].stopdate,
        };
        result.push([timingObj, activations]);
      });
      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CampaignActivationTimingsList.vue